// Preset towns around San Angelo, TX with approximate one-way distances in miles.
// Round-trip miles = 2 * one_way; mileage fee = $3 * round_trip_miles.
export const SERVICE_TOWNS = [
  { name: "San Angelo", oneWay: 0 },
  { name: "Wall", oneWay: 10 },
  { name: "Miles", oneWay: 18 },
  { name: "Christoval", oneWay: 20 },
  { name: "Mertzon", oneWay: 25 },
  { name: "Paint Rock", oneWay: 30 },
  { name: "Ballinger", oneWay: 35 },
  { name: "Eden", oneWay: 45 },
  { name: "Eldorado", oneWay: 45 },
  { name: "Sonora", oneWay: 65 },
  { name: "Big Lake", oneWay: 70 },
  { name: "Brady", oneWay: 75 },
  { name: "Ozona", oneWay: 80 },
  { name: "Big Spring", oneWay: 85 },
  { name: "Abilene", oneWay: 90 },
  { name: "Midland", oneWay: 90 },
  { name: "Other (outside list)", oneWay: -1 },
];

export const MILEAGE_RATE = 3;
export const MINIMUM_FEE = 99;
export const PRICE_SINGLE_OUT = 10;
export const PRICE_INSIDE = 7;
export const PRICE_SECOND_OUT = 20;

export function getRoundTripMiles(town, manualMiles) {
  if (!town) return 0;
  if (town.oneWay === -1) {
    const m = Number(manualMiles);
    return isFinite(m) && m > 0 ? m * 2 : 0;
  }
  return town.oneWay * 2;
}

// Canonical pricing logic shared between calculator + form.
// Rule: $99 is the minimum visit fee; window charges ABSORB the first $99
// (so you pay max($99, window_subtotal) + mileage).
export function computeQuote(state) {
  const singleOutTotal = (state.singleOut || 0) * PRICE_SINGLE_OUT;
  const insideTotal = (state.inside || 0) * PRICE_INSIDE;
  const secondOutTotal = (state.secondOut || 0) * PRICE_SECOND_OUT;
  const windowSubtotal = singleOutTotal + insideTotal + secondOutTotal;
  const roundTrip = getRoundTripMiles(state.town, state.manualMiles);
  const mileageFee = roundTrip * MILEAGE_RATE;
  const minimumApplied = windowSubtotal < MINIMUM_FEE;
  const effectiveWindows = Math.max(MINIMUM_FEE, windowSubtotal);
  const total = effectiveWindows + mileageFee;
  return {
    singleOutTotal,
    insideTotal,
    secondOutTotal,
    windowSubtotal,
    roundTrip,
    mileageFee,
    minimumApplied,
    effectiveWindows,
    total,
  };
}
